import { SupportedTLD } from '@peloton/internationalize';
import { PELOTON_PLATFORM } from '@webtv/env';
import { getTLD } from './locale';
export var toCheckoutUrl = function toCheckoutUrl(locale) {
  var extraPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var tld = getTLD(locale);
  var platform;

  switch (PELOTON_PLATFORM) {
    case 'sky_tv':
      platform = 'sky'; // only available in the UK for now

      tld = SupportedTLD.CoUk;
      break;

    case 'lg':
      platform = 'lg';
      break;

    case 'samsung':
      platform = 'samsung';
      break;

    default:
      platform = 'app';
  }

  return "www.onepeloton".concat(tld, "/").concat(platform).concat(extraPath);
};